export const ROLES = {
  AdminOwner: "ROLE_ADMIN_OWNER",
  AdminSuper: "ROLE_ADMIN_SUPER",
};

export const ROLENAME = {
  ROLE_ADMIN_OWNER: "ADMIN",
};
